import Box from '@mui/material/Box';
import type { SxProps } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { ExpandableSectionWithAccordion } from './ExpandableSectionWithAccordion.tsx';

type BaseFilterSectionProps = {
  titleKey: string;
  dataTestId: string;
  selectedCount: number;
  onClear: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  summary?: string;
  showClearButton?: boolean;
  hideCountInTitle?: boolean;
  hideSubtitle?: boolean;
  expandableWhenEmpty?: boolean;
  expandableSectionStyles?: {
    accordionDetails: SxProps;
  };
  isExpanded: boolean;
  onToggleExpand: () => void;
};

export const BaseFilterSection = ({
  titleKey,
  dataTestId,
  selectedCount,
  onClear,
  children,
  summary,
  showClearButton,
  hideCountInTitle = false,
  hideSubtitle = false,
  expandableWhenEmpty = false,
  expandableSectionStyles,
  isExpanded,
  onToggleExpand,
}: BaseFilterSectionProps) => {
  const { t } = useTranslation();

  const hasSelections = selectedCount > 0;

  const subtitle = hideSubtitle ? '' : hasSelections ? '' : t('Any');
  const translatedTitle = t(titleKey);
  const sectionTitle = hideCountInTitle
    ? translatedTitle
    : hasSelections
      ? `${translatedTitle} [ ${selectedCount} ]`
      : translatedTitle;

  return (
    <ExpandableSectionWithAccordion
      title={sectionTitle}
      expandable={expandableWhenEmpty || hasSelections}
      summary={summary}
      dataTest={dataTestId}
      subtitle={subtitle}
      onClear={onClear}
      showClearButton={showClearButton !== undefined ? showClearButton : hasSelections}
      expandableSectionStyles={expandableSectionStyles}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
    >
      <Box sx={{ p: 1 }}>{children}</Box>
    </ExpandableSectionWithAccordion>
  );
};
